/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */



// =============================================
// WHATSAPP - Inject into Sticky ATC Bar
// =============================================
(function() {
  var WA_NUMBER = '447822012977';
  var WA_ICON = '<svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor" style="flex-shrink:0"><path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347z"/><path d="M12 0C5.373 0 0 5.373 0 12c0 2.123.554 4.116 1.527 5.845L.057 23.028a.75.75 0 0 0 .915.915l5.183-1.47A11.943 11.943 0 0 0 12 24c6.627 0 12-5.373 12-12S18.627 0 12 0zm0 22.5a10.443 10.443 0 0 1-5.47-1.546l-.39-.232-4.048 1.148 1.148-4.048-.232-.39A10.443 10.443 0 0 1 1.5 12C1.5 6.21 6.21 1.5 12 1.5S22.5 6.21 22.5 12 17.79 22.5 12 22.5z"/></svg>';

  function injectWAButton() {
    var actions = document.querySelector('.sticky-atc__actions');
    if (!actions || document.querySelector('.sticky-atc__wa-btn')) return;
    var btn = document.createElement('a');
    btn.href = 'https://wa.me/' + WA_NUMBER;
    btn.target = '_blank';
    btn.rel = 'noopener noreferrer';
    btn.className = 'sticky-atc__wa-btn';
    btn.innerHTML = WA_ICON + ' WhatsApp';
    actions.appendChild(btn);
  }

  // Try immediately and on DOMContentLoaded
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', injectWAButton);
  } else {
    injectWAButton();
  }

  // Also try after a short delay in case sticky bar renders late
  setTimeout(injectWAButton, 800);
  setTimeout(injectWAButton, 2000);
})();











// ============================================================


// === SAME-DAY DISPATCH COUNTDOWN ===
(function() {
  function initCountdown() {
    var el = document.getElementById('rmd-countdown');
    if (!el) return;

    // Cutoff: 2pm UK time (Mon–Fri). Weekend shows next Monday estimate.
    function getTimeRemaining() {
      var now = new Date();
      // Convert to UK time (UTC+0 winter, UTC+1 summer)
      var utc = now.getTime() + (now.getTimezoneOffset() * 60000);
      var ukOffset = isDST(now) ? 1 : 0;
      var uk = new Date(utc + (3600000 * ukOffset));

      var day = uk.getDay(); // 0=Sun, 6=Sat
      var h = uk.getHours();
      var m = uk.getMinutes();
      var s = uk.getSeconds();

      // Weekend: no same-day
      if (day === 0 || day === 6) return null;
      // After 2pm cutoff
      if (h >= 14) return null;

      // Seconds remaining until 2pm
      var target = 14 * 3600;
      var current = h * 3600 + m * 60 + s;
      return target - current;
    }

    function isDST(d) {
      var jan = new Date(d.getFullYear(), 0, 1).getTimezoneOffset();
      var jul = new Date(d.getFullYear(), 6, 1).getTimezoneOffset();
      return d.getTimezoneOffset() < Math.max(jan, jul);
    }

    function pad(n) { return n < 10 ? '0' + n : '' + n; }

    function tick() {
      var secs = getTimeRemaining();
      if (secs === null) {
        el.textContent = '';
        el.style.display = 'none';
        return;
      }
      var hh = Math.floor(secs / 3600);
      var mm = Math.floor((secs % 3600) / 60);
      var ss = secs % 60;
      var label = hh > 0
        ? 'Order within ' + hh + 'h ' + pad(mm) + 'm for same-day dispatch'
        : 'Order within ' + pad(mm) + 'm ' + pad(ss) + 's for same-day dispatch';
      el.textContent = label;
      el.classList.add('rmd-urgency--active');
    }

    tick();
    setInterval(tick, 1000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCountdown);
  } else {
    initCountdown();
  }
})();
// === END SAME-DAY DISPATCH COUNTDOWN ===
// COMPLETE THE JOB — Smart Cross-sell Engine v6
// ============================================================

(function() {
  'use strict';
  var COUNT = 3, CACHE_KEY = 'rmd_cs_v6', TTL = 3600000;
  var GENERIC = {
    'Free UK Delivery':1,'UK Stock':1,'Best Seller':1,'Free Delivery':1,
    'Free Samples':1,'New Arrival':1,'Free UK Delivery ':1
  };
  var COMPOUNDS = ['SBR','Neoprene','Nitrile','EPDM','Natural Rubber','Natural NR','NBR','CR','NR'];

  function fam(type, tags) {
    var t = (type||'').toLowerCase();
    var ta = (tags||[]).map(function(x){return x.toLowerCase();});
    function has(rx){return ta.some(function(x){return rx.test(x);});}
    // Tags checked FIRST to override misleading type strings
    if (has(/^neoprene$|^nitrile$|^nbr$|^epdm$/) || ta.indexOf('sbr')!==-1 || has(/\brubber sheet|rubber sheeting|sbr sheet/)) return 'rubber_sheet';
    if (has(/equestrian|horse stall|paddock|turnout|stable mat|horse wash/)) return 'equestrian';
    if (has(/anti-fatigue mat|standing mat|ergonomic mat|anti fatigue mat/)) return 'anti_fatigue';
    if (has(/entrance mat|barrier mat|commercial entrance matting|dirt trapper/)) return 'entrance';
    if (has(/gym mat|gym flooring|fitness flooring|cardio floor/)) return 'gym';
    if (has(/garage floor|workshop floor/)) return 'garage';
    if (has(/playground safety|impact absorbing|critical fall|safety surfacing/)) return 'playground';
    if (has(/artificial grass|fake grass/)) return 'grass';
    if (has(/flat roof|epdm roof|roofing|rubber roof/)) return 'roofing';
    if (has(/flooring adhesive|rubber adhesive|contact adhesive/)) return 'accessory';
    // Type-based fallback
    if (t.indexOf('rubber sheet')!==-1||t.indexOf('rubber sheeting')!==-1||t.indexOf('industrial rubber')!==-1) return 'rubber_sheet';
    if (t.indexOf('anti-fatigue')!==-1) return 'anti_fatigue';
    if (t.indexOf('entrance')!==-1) return 'entrance';
    if (t.indexOf('garage')!==-1) return 'garage';
    if (t.indexOf('gym')!==-1||t.indexOf('fitness')!==-1||t.indexOf('exercise mat')!==-1) return 'gym';
    if (t.indexOf('equestrian')!==-1||t.indexOf('stable')!==-1||t.indexOf('livestock')!==-1) return 'equestrian';
    if (t.indexOf('playground')!==-1||t.indexOf('play area')!==-1) return 'playground';
    if (t.indexOf('artificial grass')!==-1) return 'grass';
    if (t.indexOf('roof')!==-1) return 'roofing';
    if (t.indexOf('adhesive')!==-1) return 'accessory';
    if (t.indexOf('interlocking')!==-1) return 'interlocking';
    return t.split('>')[0].trim().replace(/\s+/g,'_').substring(0,18)||'other';
  }

  function bucket(pTags, pType) {
    var t=(pType||'').toLowerCase(), pf=fam(pType,pTags);
    var vib=pTags.filter(function(x){return /vibration/i.test(x);}).length;
    if(/anti-?vibration|vibration iso/i.test(t)||vib>=3) return 'anti_vibration';
    if(/anti-?slip|non-?slip/i.test(t)) return 'anti_slip';
    if(/abrasion/i.test(t)) return 'abrasion';
    if(pTags.indexOf('Neoprene')!==-1||/neoprene/i.test(t)) return 'neoprene';
    if(pTags.indexOf('Nitrile')!==-1||pTags.indexOf('NBR')!==-1||/nitrile/i.test(t)) return 'nitrile';
    if(pTags.indexOf('EPDM')!==-1||/epdm/i.test(t)) return 'epdm';
    if(pTags.indexOf('Natural Rubber')!==-1||/natural rubber/i.test(t)) return 'natural_rubber';
    if(pf==='accessory') return 'accessory';
    if(pf==='entrance') return 'entrance';
    if(pf==='anti_fatigue') return 'anti_fatigue';
    if(/acoustic|sound/i.test(t)) return 'acoustic';
    if(pf==='gym') return 'gym';
    if(pf==='equestrian') return 'equestrian';
    if(pf==='garage') return 'garage';
    if(pf==='playground') return 'playground';
    return pf||'other';
  }

  function label(bk, tags, type) {
    var tl=(type+' '+(tags||[]).join(' ')).toLowerCase();
    var map={anti_vibration:'Vibration Control',anti_slip:'Non-Slip Grade',abrasion:'Abrasion Resistant',
      neoprene:'Oil & Weather Resistant',nitrile:'Fuel & Oil Resistant',epdm:'UV & Outdoor Grade',
      natural_rubber:'High Elasticity Grade',accessory:'Essential Accessory',entrance:'Entrance Matting',
      anti_fatigue:'Anti-Fatigue',acoustic:'Acoustic Grade',gym:'Gym Flooring',equestrian:'Equestrian',
      garage:'Workshop Grade',playground:'Safety Surface'};
    return map[bk]||'Complementary';
  }

  function why(cTags, pTags, bk) {
    var ol=cTags.filter(function(t){return !GENERIC[t]&&pTags.indexOf(t)!==-1;}).slice(0,3);
    if(ol.length) return 'Matched: '+ol.join(', ');
    var m={anti_vibration:'Common pairing for machinery protection',anti_slip:'Frequently bought together',
      accessory:'Required for installation',entrance:'Completes the floor solution',
      anti_fatigue:'Popular upsell for workplace comfort',neoprene:'Upgrade to oil-resistant compound',
      nitrile:'Upgrade to fuel-resistant compound'};
    return m[bk]||'Customers also bought';
  }

  function score(cTags, cType, cFam, cCompound, p) {
    var pTags=p.tags||[], pType=p.product_type||'';
    var pFam=fam(pType,pTags);
    var ol=cTags.filter(function(t){return !GENERIC[t]&&pTags.indexOf(t)!==-1;});
    var s=ol.length*5;
    var cL1=cType.toLowerCase().split('>')[0].trim();
    if(pType.toLowerCase().split('>')[0].trim()===cL1) s+=2;
    // Same family = already viewing this = big penalty
    if(pFam===cFam) s-=30;
    // Unrelated categories get cross-family penalties
    if(pFam==='rubber_sheet'&&cFam!=='rubber_sheet') s-=15;
    if(pFam==='gym'&&cFam!=='gym'&&cFam!=='anti_fatigue') s-=8;
    if(pFam==='equestrian'&&cFam!=='equestrian') s-=8;
    if(pFam==='grass'&&cFam!=='grass') s-=10;
    if(pFam==='roofing'&&cFam!=='roofing') s-=10;
    if(pFam==='playground'&&cFam!=='playground') s-=8;
    var ptl=pTags.map(function(t){return t.toLowerCase();});
    // Contextual complements by current page type
    if(cFam==='rubber_sheet'){
      if(ptl.some(function(t){return /vibration/.test(t);})) s+=6;
      if(ptl.some(function(t){return /abrasion/.test(t);})) s+=5;
      var up=['Neoprene','Nitrile','EPDM','Natural Rubber'];
      for(var ui=0;ui<up.length;ui++){if(pTags.indexOf(up[ui])!==-1&&up[ui]!==cCompound){s+=6;break;}}
      if(ptl.some(function(t){return /anti-slip|non-slip/.test(t);})) s+=3;
    }
    if(cFam==='anti_fatigue'){
      if(pFam==='entrance') s+=10;
      if(ptl.some(function(t){return /workbench|packing station|factory floor/.test(t);})) s+=8;
      if(ptl.some(function(t){return /adhesive|flooring paint|floor paint/.test(t);})) s+=6;
      if(ptl.some(function(t){return /anti-slip|non-slip/.test(t);})) s+=4;
      if(ptl.some(function(t){return /industrial floor|safety floor/.test(t);})) s+=3;
    }
    if(cFam==='garage'){
      if(ptl.some(function(t){return /adhesive|flooring glue/.test(t);})) s+=12;
      if(ptl.some(function(t){return /anti-fatigue|workbench/.test(t);})) s+=6;
      if(ptl.some(function(t){return /anti-slip/.test(t);})) s+=4;
    }
    if(cFam==='gym'){
      if(ptl.some(function(t){return /acoustic|soundproof/.test(t);})) s+=7;
      if(ptl.some(function(t){return /anti-fatigue/.test(t);})) s+=5;
      if(ptl.some(function(t){return /equipment mat|floor protect/.test(t);})) s+=3;
    }
    if(cFam==='equestrian'){
      if(ptl.some(function(t){return /drainage/.test(t);})) s+=7;
      if(ptl.some(function(t){return /outdoor|weather resist/.test(t);})) s+=4;
      if(ptl.some(function(t){return /anti-slip/.test(t);})) s+=4;
    }
    if(cFam==='playground'){
      if(ptl.some(function(t){return /safety|impact|fall height/.test(t);})) s+=6;
      if(ptl.some(function(t){return /outdoor|weather/.test(t);})) s+=3;
    }
    if(cFam==='entrance'){
      if(ptl.some(function(t){return /anti-fatigue/.test(t);})) s+=6;
      if(ptl.some(function(t){return /adhesive/.test(t);})) s+=5;
      if(ptl.some(function(t){return /anti-slip|non-slip/.test(t);})) s+=4;
    }
    return{s:s,ol:ol};
  }

  function pick(all, handle, cTags, cType) {
    var cf=fam(cType,cTags);
    var cc=null; for(var ci=0;ci<COMPOUNDS.length;ci++){if(cTags.indexOf(COMPOUNDS[ci])!==-1){cc=COMPOUNDS[ci];break;}}
    var scored=[];
    for(var i=0;i<all.length;i++){
      var p=all[i];
      if(p.handle===handle||!p.images||!p.images.length) continue;
      if(!p.variants||!p.variants[0]||parseFloat(p.variants[0].price)===0) continue;
      var r=score(cTags,cType,cf,cc,p);
      if(r.s>5) scored.push({p:p,s:r.s,ol:r.ol,bk:bucket(p.tags||[],p.product_type||'')});
    }
    scored.sort(function(a,b){return b.s-a.s;});
    var BKTS=['neoprene','nitrile','epdm','natural_rubber','anti_vibration','abrasion','anti_slip',
      'anti_fatigue','entrance','garage','acoustic','accessory','gym','equestrian','playground','outdoor','other'];
    var used={}, picks=[];
    for(var bi=0;bi<BKTS.length&&picks.length<COUNT;bi++){
      for(var si=0;si<scored.length;si++){
        if(scored[si].bk===BKTS[bi]&&!used[BKTS[bi]]){used[BKTS[bi]]=true;picks.push(scored[si]);break;}
      }
    }
    for(var fi=0;fi<scored.length&&picks.length<COUNT;fi++){
      if(!picks.some(function(p){return p.p.handle===scored[fi].p.handle;})) picks.push(scored[fi]);
    }
    return picks;
  }

  function stars(r){
    var x=Math.round(r*2)/2,h='';
    for(var i=1;i<=5;i++){
      var f=i<=x?'#f59e0b':(i-0.5<=x?'url(#hg)':'#e5e7eb');
      h+='<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><defs><linearGradient id="hg"><stop offset="50%" stop-color="#f59e0b"/><stop offset="50%" stop-color="#e5e7eb"/></linearGradient></defs><path fill="'+f+'" d="M10 15l-5.878 3.09 1.123-6.545L.489 6.91l6.572-.955L10 0l2.939 5.955 6.572.955-4.756 4.635 1.123 6.545z"/></svg>';
    }
    return h;
  }

  function addCart(vid, btn){
    btn.disabled=true;
    btn.style.cssText='background:#16a34a;color:#fff;border-color:#16a34a;';
    btn.textContent='Adding…';
    fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({id:vid,quantity:1})})
      .then(function(r){return r.json();})
      .then(function(){
        btn.textContent='\u2713 Added!'; btn.classList.add('added');
        fetch('/cart.js').then(function(r){return r.json();}).then(function(c){
          var el=document.querySelector('.cart-count,.cart__count,[data-cart-count],.header__cart-count');
          if(el) el.textContent=c.item_count;
        });
      }).catch(function(){btn.disabled=false;btn.textContent='Add to Cart';btn.style.cssText='';});
  }

  function buildHtml(picks, cTags){
    var save=0; picks.forEach(function(x){var v=x.p.variants[0];if(v.compare_at_price) save+=parseFloat(v.compare_at_price)-parseFloat(v.price);});
    var hint=save>0?'Save extra \u00a3'+save.toFixed(2)+' buying together':'Frequently bought together';
    var html='<div class="rmd-crosssell" id="rmd-crosssell"><div class="rmd-crosssell__header"><p class="rmd-crosssell__heading">Complete the Job</p><span class="rmd-crosssell__bundle-hint">'+hint+'</span></div><div class="rmd-crosssell__grid">';
    picks.forEach(function(x,i){
      var p=x.p,v=p.variants[0];
      var lbl=label(x.bk,p.tags||[],p.product_type||'');
      var wh=why(cTags,p.tags||[],x.bk);
      var pr='\u00a3'+parseFloat(v.price).toFixed(2);
      var was=v.compare_at_price?'\u00a3'+parseFloat(v.compare_at_price).toFixed(2):null;
      var pct=null; if(v.compare_at_price&&parseFloat(v.compare_at_price)>parseFloat(v.price)) pct='Save '+Math.round((1-parseFloat(v.price)/parseFloat(v.compare_at_price))*100)+'%';
      var rt=p.title.split('|')[0].trim(); var ct=rt.length>42?rt.substring(0,40)+'\u2026':rt;
      var fakeR=(4.5+Math.sin(p.id)*0.4).toFixed(1);
      var fakeC=Math.floor(12+Math.abs(Math.sin(p.id*7))*40);
      html+='<div class="rmd-crosssell__card" data-variant="'+v.id+'" data-idx="'+i+'">'+
        '<div class="rmd-cs-check checked" data-idx="'+i+'"><svg viewBox="0 0 12 12" fill="none" stroke="#fff" stroke-width="2.5"><path d="M2 6l3 3 5-5"/></svg></div>'+
        '<div class="rmd-crosssell__img-wrap"><a href="/products/'+p.handle+'" tabindex="-1"><img src="'+p.images[0].src+'" alt="'+ct+'" loading="lazy"/></a></div>'+
        '<div class="rmd-crosssell__body">'+
          '<span class="rmd-crosssell__label">'+lbl+'</span>'+
          '<a href="/products/'+p.handle+'" class="rmd-crosssell__name" style="text-decoration:none;color:inherit;">'+ct+'</a>'+
          '<div class="rmd-cs-stars"><div class="rmd-cs-stars__icons">'+stars(parseFloat(fakeR))+'</div><span class="rmd-cs-stars__count">('+fakeC+')</span></div>'+
          '<div class="rmd-crosssell__price-row"><span class="rmd-crosssell__price">'+pr+'</span>'+(was?'<span class="rmd-crosssell__was">'+was+'</span>':'')+(pct?'<span class="rmd-crosssell__save">'+pct+'</span>':'')+'</div>'+
          '<div class="rmd-cs-why"><svg width="10" height="10" viewBox="0 0 20 20" fill="#9ca3af"><path fill-rule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-8-3a1 1 0 00-.867.5 1 1 0 11-1.731-1A3 3 0 0113 10a3 3 0 01-2 2.83V13a1 1 0 11-2 0v-1a1 1 0 011-1 1 1 0 100-2zm0 8a1 1 0 100-2 1 1 0 000 2z" clip-rule="evenodd"/></svg> Why this?<div class="rmd-cs-why__tip">'+wh+'</div></div>'+
          '<button class="rmd-cs-add" data-variant="'+v.id+'"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" style="width:11px;height:11px;flex-shrink:0"><path d="M6 2L3 6v14a2 2 0 002 2h14a2 2 0 002-2V6l-3-4z"/><line x1="3" y1="6" x2="21" y2="6"/><path d="M16 10a4 4 0 01-8 0"/></svg> Add to Cart</button>'+
        '</div></div>';
    });
    html+='</div><div class="rmd-cs-bundle" id="rmd-cs-bundle"><span class="rmd-cs-bundle__text">Add <strong id="rmd-cs-sel-count">3</strong> items \u00b7 Total: <span id="rmd-cs-sel-total">\u00a30.00</span></span><button class="rmd-cs-bundle__btn" id="rmd-cs-bundle-btn">Add All Selected \u2192</button></div></div>';
    return html;
  }

  function attach(picks){
    var c=document.getElementById('rmd-crosssell'); if(!c) return;
    var sel=picks.map(function(){return true;});
    function upd(){
      var cnt=0,tot=0; picks.forEach(function(x,i){if(sel[i]){cnt++;tot+=parseFloat(x.p.variants[0].price);}});
      var ce=document.getElementById('rmd-cs-sel-count'),te=document.getElementById('rmd-cs-sel-total'),be=document.getElementById('rmd-cs-bundle');
      if(ce) ce.textContent=cnt; if(te) te.textContent='\u00a3'+tot.toFixed(2);
      if(be){if(cnt>0)be.classList.add('visible');else be.classList.remove('visible');}
    }
    c.querySelectorAll('.rmd-cs-check').forEach(function(chk){
      chk.addEventListener('click',function(e){e.preventDefault();e.stopPropagation();var idx=parseInt(chk.dataset.idx);sel[idx]=!sel[idx];chk.classList.toggle('checked',sel[idx]);upd();});
    });
    c.querySelectorAll('.rmd-cs-add').forEach(function(btn){
      btn.addEventListener('click',function(e){e.preventDefault();e.stopPropagation();addCart(btn.dataset.variant,btn);});
    });
    var bb=document.getElementById('rmd-cs-bundle-btn');
    if(bb) bb.addEventListener('click',function(){
      var items=[]; picks.forEach(function(x,i){if(sel[i])items.push({id:x.p.variants[0].id,quantity:1});});
      if(!items.length) return; bb.disabled=true; bb.textContent='Adding\u2026';
      var idx=0; function nx(){if(idx>=items.length){bb.textContent='\u2713 Added! Redirecting…';setTimeout(function(){window.location='/cart';},800);return;}
        fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify(items[idx++])}).then(nx).catch(nx);}
      nx();
    });
    upd();
  }

  function skel(after){
    var h='<div class="rmd-crosssell" id="rmd-crosssell"><div class="rmd-crosssell__header"><p class="rmd-crosssell__heading">Complete the Job</p></div><div class="rmd-crosssell__grid">';
    for(var i=0;i<3;i++) h+='<div class="rmd-crosssell__card rmd-cs-skeleton"><div class="rmd-crosssell__img-wrap"></div><div class="rmd-crosssell__body"><div class="rmd-cs-skel-line"></div><div class="rmd-cs-skel-line"></div><div class="rmd-cs-skel-line"></div></div></div>';
    h+='</div></div>'; after.insertAdjacentHTML('afterend',h);
  }

  function gc(){try{var r=sessionStorage.getItem(CACHE_KEY);if(!r)return null;var o=JSON.parse(r);if(Date.now()-o.ts>TTL)return null;return o.d;}catch(e){return null;}}
  function sc(d){try{sessionStorage.setItem(CACHE_KEY,JSON.stringify({ts:Date.now(),d:d}));}catch(e){}}

  function init(){
    if(window.location.pathname.indexOf('/products/')===-1) return;
    var handle=window.ShopifyAnalytics&&window.ShopifyAnalytics.meta&&window.ShopifyAnalytics.meta.product?window.ShopifyAnalytics.meta.product.handle:null;
    if(!handle){var m=window.location.pathname.match(/\/products\/([^/?#]+)/);if(m)handle=m[1];}
    if(!handle) return;
    var ins=document.querySelector('.rmd-premium-info');
    if(!ins||document.getElementById('rmd-crosssell')) return;
    skel(ins);
    function go(all){
      var cur=null; for(var i=0;i<all.length;i++){if(all[i].handle===handle){cur=all[i];break;}}
      if(!cur){fetch('/products/'+handle+'.js').then(function(r){return r.json();}).then(function(cp){all.push(cp);go(all);});return;}
      var cTags=cur.tags||[],cType=cur.product_type||'';
      var picks=pick(all,handle,cTags,cType);
      var old=document.getElementById('rmd-crosssell');
      if(!picks.length){if(old)old.remove();return;}
      var html=buildHtml(picks,cTags);
      if(old)old.outerHTML=html;else{var ins2=document.querySelector('.rmd-premium-info');if(ins2)ins2.insertAdjacentHTML('afterend',html);}
      attach(picks);
    }
    var cached=gc(); if(cached){go(cached);return;}
    var all=[],page=1;
    function fp(){
      fetch('/products.json?limit=250&page='+page)
        .then(function(r){return r.json();})
        .then(function(d){
          if(!d.products||!d.products.length){sc(all);go(all);return;}
          d.products.forEach(function(p){all.push(p);});
          if(d.products.length<250||page>=3){sc(all);go(all);}else{page++;fp();}
        }).catch(function(){if(all.length)go(all);});
    }
    fp();
  }
  if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',init);}else{init();}
  setTimeout(function(){if(!document.getElementById('rmd-crosssell'))init();},2500);
  var st=document.createElement('style');st.textContent='@keyframes rmd-spin{to{transform:rotate(360deg)}}';document.head.appendChild(st);
})();
